export { namespace } from './actions';
import { Status, ActionType } from './actions';

const initialState = {
  status: Status.INITIAL,
  timeZones: []
};

export default function timeZoneReducer(state = initialState, action) {

  switch (action.type) {
    case ActionType.SET_TIME_ZONES: {
      const { timeZones = [] } = action.payload;
      return {
        ...state,
        status: Status.LOADED,
        timeZones: [...timeZones]
      };
    }
    case ActionType.SET_TIME_ZONE_STATUS: {
      const { status } = action.payload;
      return {
        ...state,
        status
      }
    }
    default:
      return state;
  }
}
